// extracted by mini-css-extract-plugin
export default {"TabsLeft__subtab":"TabsLeftNav_TabsLeft__subtab__6+YTc","TabsLeft__subtab_container":"TabsLeftNav_TabsLeft__subtab_container__GCMnQ"};